<template>
  <div
    class="machine-apr-list"
    :class="{ print: prepareForPrint }"
    v-if="machineAprs?.length > 0"
  >
    <table class="machine-apr-list__table table-striped table-bordered">
      <thead>
        <tr class="bg-secondary text-light">
          <th class="text-center">ID</th>
          <th class="text-center">Foto</th>
          <th class="text-center">
            <div class="rotated">Natureza do Risco</div>
          </th>
          <th class="text-center">
            <div class="rotated">Multa prevista (R$)</div>
          </th>
          <th class="text-center">
            <div class="rotated">Item da Norma</div>
          </th>
          <th class="text-center">
            <div class="rotated">Local da Não Conformidade</div>
          </th>
          <th class="text-center">Descrição</th>
          <th class="text-center">Tratativa</th>
          <th class="text-center">Obs</th>
          <th class="text-center">Medidas</th>
          <th class="text-center">Análise de Risco</th>
          <th class="text-center no-print">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="apr in machineAprs"
          :key="apr.id"
          class="machine-apr-list__item prevent-print-cut"
        >
          <td>{{ apr.id }}</td>
          <!-- ID -->
          <td>
            <analysis-images-gallery
              v-if="!prepareForPrint && apr.pictures_url.length > 1"
              :images="apr.pictures_url"
              @open-gallery="handleOpenGallery"
            ></analysis-images-gallery>
            <img
              class="table-image expandable-image"
              :src="apr.picture_url"
              alt=""
              @click="showSingleImage(apr.picture_url)"
              v-if="!prepareForPrint && apr.pictures_url.length == 1"
            />
            <div v-if="prepareForPrint && apr.thumbnail_pictures_url.length > 1" class="analysis-images-gallery-grid">
                <div
                    v-for="(image, i) in apr.thumbnail_pictures_url"
                    :key="i"
                    class="image-thumb-holder"
                >
                    <img
                        :src="image"
                        alt=""
                        class="image-thumb"
                    />
                </div>
            </div>
            <img
              class="table-image expandable-image"
              :src="apr.picture_url"
              alt=""
              @click="showSingleImage(apr.picture_url)"
              v-if="prepareForPrint && apr.thumbnail_pictures_url.length == 1"
            />
          </td>
          <td v-if="false">
            <img
              class="table-image expandable-image"
              :src="apr.picture_url"
              alt=""
              @click="showSingleImage(apr.picture_url)"
              v-if="!prepareForPrint"
            />
            <img
              class="table-image"
              :src="apr.thumbnail_picture_url"
              alt=""
              v-if="prepareForPrint"
            />
          </td>
          <!-- Foto -->
          <td class="text-vertical">
            <div class="rotated">
              {{ apr?.nature_of_risk_alternative || '-' }}
            </div>
          </td>
          <td>
            <div class="rotated">
              {{ apr?.max_fine_value || '-' }}
            </div>
          </td>
          <!-- Natureza do risco -->
          <td class="text-vertical">
            <div class="rotated">
              {{
                apr?.standard_item_alternative ||
                standardItemsToString(apr) ||
                '-'
              }}
            </div>
          </td>
          <!-- Item da norma -->
          <td class="text-sm text-vertical">
            <div class="rotated">
              {{ apr?.noncompliance_placement || '-' }}
            </div>
          </td>
          <!-- Local da Não conformidade -->
          <td class="text-sm">
            {{ apr?.noncompliance || '-' }}
          </td>
          <!-- Descrição -->
          <td class="text-sm">
            {{ apr?.treatise_alternative || '-' }}
          </td>
          <!-- Tratativa -->
          <td class="text-sm">
            {{ apr?.additional_observations || '-'}}
          </td>
          <!-- Observação -->
          <td>
            <!-- Medidas -->
            <div v-if="apr.height"><b>Altura:</b> {{ apr.height }}</div>
            <div v-if="apr.length"><b>Comprimento:</b> {{ apr.length }}</div>
            <div v-if="apr.depth"><b>Profundidade:</b> {{ apr.depth }}</div>
            <div v-if="apr.circunference">
              <b>Circunferência:</b> {{ apr.circunference }}
            </div>
            <div v-if="apr.linear_measurement">
              <b>Metragem Linear:</b> {{ apr.linear_measurement }}
            </div>
            <div
              v-if="
                !apr.height &&
                !apr.length &&
                !apr.depth &&
                !apr.circunference &&
                !apr.linear_measurement
              "
            >
              -
            </div>
          </td>

          <td class="no-padding" v-if="apr?.calculated_hrn_level != 0">
            <table class="inner-table mb-2">
              <tbody>
                <tr
                  class="table-title clickable"
                  @click="showSingleImage(METRIC_IMAGES.hrn)"
                >
                  <td colspan="6">HRN</td>
                </tr>
                <tr>
                  <th
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.hrn_po)"
                  >
                    PO
                  </th>
                  <th
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.hrn_gpd)"
                  >
                    GPD
                  </th>
                  <th
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.hrn_fe)"
                  >
                    FE
                  </th>
                  <th
                    class="clickable"
                    @click="showSingleImage(METRIC_IMAGES.hrn_np)"
                  >
                    NP
                  </th>
                  <th>RES</th>
                </tr>
                <tr>
                  <td @click="editHRN(apr)">{{ apr.po || '-' }}</td>
                  <td @click="editHRN(apr)">{{ apr.gpd || '-' }}</td>
                  <td @click="editHRN(apr)">{{ apr.fe || '-' }}</td>
                  <td @click="editHRN(apr)">{{ apr.np || '-' }}</td>
                  <td
                    :class="{ unacceptable: apr.hrn_level === 8 }"
                    :style="`background-color: ${getHrnLevelColor(
                      apr.hrn_level,
                    )}`"
                    width="60px"
                  >
                    {{ apr.hrn_result || '-' }}
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="inner-table mb-2">
              <tbody>
                <tr
                  class="table-title clickable"
                  @click="showSingleImage(METRIC_IMAGES.iso12100)"
                >
                  <td colspan="6">ISO 12100</td>
                </tr>
                <tr>
                  <th
                    class="table-title clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso12100_quesitos)"
                  >
                    Sev.
                  </th>
                  <th
                    class="table-title clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso12100_quesitos)"
                  >
                    Freq.
                  </th>
                  <th
                    class="table-title clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso12100_quesitos)"
                  >
                    Poss.
                  </th>
                  <th
                    class="table-title clickable"
                    @click="showSingleImage(METRIC_IMAGES.iso12100_quesitos)"
                  >
                    Pre.
                  </th>
                  <th>RES.</th>
                </tr>

                <tr>
                  <td>{{ apr.iso_12100_severity || '-' }}</td>
                  <td>{{ apr.iso_12100_exposure || '-' }}</td>
                  <td>{{ apr.iso_12100_probability || '-' }}</td>
                  <td>{{ apr.iso_12100_prevention || '-' }}</td>
                  <td
                    :style="{
                      backgroundColor: getIso12100LevelColor(
                        apr.iso_12100_level,
                      ),
                    }"
                  >
                    {{ apr.iso_12100_result || '-' }}
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="inner-table" v-if="isCompanyMondelez">
              <tbody>
                <tr class="table-title">
                  <td colspan="6">Mondelez</td>
                </tr>
                <tr>
                  <th>Sev.</th>
                  <th>Prob.</th>
                  <th>Res.</th>
                </tr>
                <tr>
                  <td>{{ apr.mondelez_severity || '-' }}</td>
                  <td>{{ apr.mondelez_probability || '-' }}</td>
                  <td
                    :style="{
                      backgroundColor: getMondelezLevelColor(
                        apr.mondelez_result,
                      ),
                    }"
                  >
                    {{ apr.mondelez_result || '-' }} ({{
                      apr.mondelez_result_label || '-'
                    }})
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td
            v-else
            class="text-center text-sm"
            :style="`background-color: ${getHrnLevelColor(0)}`"
          >
            CONFORME
          </td>

          <td class="no-print" v-if="authenticated_user !== 'Cliente somente leitura'">
            <button @click="openModal(apr)" class="btn btn-primary btn-sm">
              Editar
            </button>
            <button @click="remove(apr)" class="btn btn-danger btn-sm mt-2">
              Excluir
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <Dialog
    :closable="false"
    :visible="displayModal"
    :style="{ width: '60vw' }"
    :modal="true"
    class="modal-content modal-machines"
  >
    <template #header class="modal-header">
      <h5 class="modal-title">Editar Equipamento</h5>
      <button
        @click="closeModal()"
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <div class="modal-body">
      <div class="offset-lg-2">
        <div class="row form-group">
          <div class="col-lg-10">
            <label>Local da Não conformidade</label>
            <div class="input-group">
              <textarea
                class="form-control"
                v-model="aprSelected.noncompliance_placement"
                placeholder="-"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Descrição</label>
            <div class="input-group">
              <textarea
                class="form-control"
                v-model="aprSelected.noncompliance"
                placeholder="-"
                rows="3"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Tratativa</label>
            <div class="input-group">
              <textarea
                      class="form-control"
                      v-model="aprSelected.treatise_alternative"
                      placeholder="-"
                      rows="3"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Observação</label>
            <div class="input-group">
              <textarea
                      class="form-control"
                      v-model="aprSelected.additional_observations"
                      placeholder="-"
                      rows="3"
              ></textarea>
            </div>
          </div>
        </div>

      </div>
    </div>

    <template #footer>
      <button class="btn btn-default" @click="closeModal()">Cancelar</button>
      <button class="btn btn-success" @click="updateMachine(aprSelected)">
        Salvar
      </button>
    </template>
  </Dialog>
  <Dialog
    :closable="false"
    :visible="displayModalHRN"
    :style="{ width: '80vw' }"
    :modal="true"
    class="modal-content modal-machines"
  >
    <template #header class="modal-header">
      <div class="d-flex">
        <h5 class="modal-title mr-5">Editar HRN</h5>
        <div
          class="hrn-result"
          :class="{ unacceptable: getHrnLevel(hrn_result) === 8 }"
          :style="`background-color: ${getHrnLevelColor(
            getHrnLevel(hrn_result),
          )}`"
        >
          {{ formatHrnResult(hrn_result) }}
        </div>
      </div>
    </template>

    <div class="modal-body">
      <div class="ml-4">
        <div class="row form-group">
          <div class="col-lg-12">
            <label>PO</label>
            <div class="radiobutton-group">
              <div
                class="radiobutton-wrapper"
                v-for="(item, i) in poOptions"
                @change="calculateHrnResult()"
                :style="{ backgroundColor: item.color }"
                :key="i"
              >
                <div class="p-field-radiobutton">
                  <RadioButton
                    name="po"
                    :value="item.value"
                    :id="`po-${i}`"
                    v-model="hrnSelected.po"
                  />
                  <label :for="`po-${i}`">{{ item.description }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>GPD</label>
            <div class="radiobutton-group">
              <div
                class="radiobutton-wrapper"
                v-for="(item, i) in gpdOptions"
                @change="calculateHrnResult()"
                :style="{ backgroundColor: item.color }"
                :key="i"
              >
                <div class="p-field-radiobutton">
                  <RadioButton
                    name="gpd"
                    :value="item.value"
                    :id="`gpd-${i}`"
                    v-model="hrnSelected.gpd"
                  />
                  <label :for="`gpd-${i}`">{{ item.description }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>FE</label>
            <div class="radiobutton-group">
              <div
                class="radiobutton-wrapper"
                v-for="(item, i) in feOptions"
                @change="calculateHrnResult()"
                :style="{ backgroundColor: item.color }"
                :key="i"
              >
                <div class="p-field-radiobutton">
                  <RadioButton
                    name="fe"
                    :value="item.value"
                    :id="`fe-${i}`"
                    v-model="hrnSelected.fe"
                  />
                  <label :for="`fe-${i}`">{{ item.description }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>NP</label>
            <div class="radiobutton-group">
              <div
                class="radiobutton-wrapper"
                v-for="(item, i) in npOptions"
                @change="calculateHrnResult()"
                :style="{ backgroundColor: item.color }"
                :key="i"
              >
                <div class="p-field-radiobutton">
                  <RadioButton
                    name="np"
                    :value="item.value"
                    :id="`np-${i}`"
                    v-model="hrnSelected.np"
                  />
                  <label :for="`np-${i}`">{{ item.description }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <template #footer>
      <button class="btn btn-default" @click="closeModalHRN()">Cancelar</button>
      <button class="btn btn-success" @click="updateHRN()">
        Salvar
      </button>
    </template>
  </Dialog>
</template>

<script>
  import useHrn from '@/modules/Hrn.js'
  import useIso12100 from '@/modules/Iso12100.js'
  import useMondelez from '@/modules/Mondelez.js'
  import useImageViewer from '@/modules/ImageViewer.js'
  import Dialog from 'primevue/dialog'
  import RadioButton from 'primevue/radiobutton'
  import axios from 'axios'
  import { useStore } from 'vuex'

  import { METRIC_IMAGES } from '@/constants/images.constants.js'
  import useMachines from '../../../modules/Machine'
  import useSwal from '../../../modules/Swal'
  import ModalEditMachineApr from '../../action_plan/components/ModalEditMachineApr'

  import AnalysisImagesGallery from '@/components/preliminary_risk_analyses/components/AnalysisImagesGallery'
  import { computed } from '@vue/runtime-core'

  export default {
    components: {
      ModalEditMachineApr,
      Dialog,
      RadioButton,
    },
    setup() {
      const { getHrnLevelColor, getHrnLevel } = useHrn()
      const { getIso12100LevelColor } = useIso12100()
      const { getMondelezLevelColor } = useMondelez()
      const { showImageIndex, showSingleImage } = useImageViewer()
      const { saveMachineApr, saveAprHRN } = useMachines()
      const { showSuccessAlert, showErrorAlert, showConfirmDeletionSwal } = useSwal()
      const store = useStore()
      const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)

      return {
        getHrnLevelColor,
        getHrnLevel,
        getIso12100LevelColor,
        getMondelezLevelColor,
        showSingleImage,
        showImageIndex,
        saveMachineApr,
        saveAprHRN,
        showSuccessAlert,
        showErrorAlert,
        showConfirmDeletionSwal,
        AnalysisImagesGallery,

        METRIC_IMAGES,
        authenticated_user
      }
    },
    data() {
      return {
        displayModal: false,
        displayModalHRN: false,
        aprSelected: {
          noncompliance_placement: '',
          noncompliance: '',
          treatise_alternative: '',
          additional_observations: '',
          treatise: ''
        },
        hrnSelected: {
          po: 0,
          gpd: 0,
          fe: 0,
          np: 0,
        },
        loading: false,
        poOptions: [],
        gpdOptions: [],
        feOptions: [],
        npOptions: [],
        hrn_result: 0,
      }
    },
    props: {
      machineAprs: {
        type: Array,
        required: true,
      },
      isCompanyMondelez: {
        type: Boolean,
        required: true,
        default: false,
      },
      prepareForPrint: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    methods: {
      remove(apr) {
        this.showConfirmDeletionSwal().then(() => {
          axios.delete(`/api/machines/${apr.risk_analysis.machine_id}/risk-analysis/destroy/${apr.id}`).then(() => {
            this.showSuccessAlert();
            location.reload()
          });
        })
      },
      openModal(value) {
        this.displayModal = true
        this.aprSelected.id = value.id
        this.aprSelected.noncompliance_placement = value.noncompliance_placement
        this.aprSelected.noncompliance = value.noncompliance
        this.aprSelected.treatise_alternative = value.treatise_alternative
        this.aprSelected.additional_observations = value.additional_observations
        this.aprSelected.treatise = value.treatise
      },
      closeModal() {
        this.displayModal = false
        this.aprSelected = {
          noncompliance_placement: '',
          noncompliance: '',
          treatise_alternative: '',
          additional_observations: '',
          treatise: ''
        }
      },
      updateMachine(value) {
        if (this.machineAprs.length) {
          this.machineAprs.map((item, i) => {
            if (item.id === value.id) {
              this.machineAprs[i].noncompliance_placement =
                value.noncompliance_placement
              this.machineAprs[i].noncompliance = value.noncompliance
              this.machineAprs[i].treatise_alternative =
                value.treatise_alternative
              this.machineAprs[i].additional_observations =
                value.additional_observations

              this.saveMachineApr(this.machineAprs[i])
                .then((res) => {
                  this.showSuccessAlert()
                  console.log(res)
                })
                .catch((error) => {
                  this.showErrorAlert()
                })
                .finally(() => {})
            }
          })
        }
        this.closeModal()
      },
      editHRN(apr) {
        this.displayModalHRN = true
        this.hrnSelected.id = apr.id
        this.hrnSelected.po = apr.po
        this.hrnSelected.gpd = apr.gpd
        this.hrnSelected.fe = apr.fe
        this.hrnSelected.np = apr.np
        this.calculateHrnResult()
      },
      closeModalHRN() {
        this.displayModalHRN = false
        this.hrnSelected = {
          po: 0,
          gpd: 0,
          fe: 0,
          np: 0,
        }
      },
      updateHRN() {
        if (this.machineAprs.length) {
          this.machineAprs.map((item, i) => {
            if (item.id === this.hrnSelected.id) {
              this.machineAprs[i].po = this.hrnSelected.po
              this.machineAprs[i].gpd = this.hrnSelected.gpd
              this.machineAprs[i].fe = this.hrnSelected.fe
              this.machineAprs[i].np = this.hrnSelected.np
              this.machineAprs[i].hrn_result = this.hrn_result
              this.machineAprs[i].hrn_level = this.getHrnLevel(this.hrn_result)

              this.saveAprHRN(this.machineAprs[i])
                .then((res) => {
                  this.showSuccessAlert()
                  console.log(res)
                })
                .catch((error) => {
                  this.showErrorAlert()
                })
                .finally(() => {})
            }
          })
        }
        this.closeModalHRN()
      },
      standardItemsToString(apr) {
        return (
          apr.noncompliance_model?.standard_items?.reduce((prev, curr) => {
            return `${prev} ${curr.name}`
          }, '') || '-'
        )
      },
      handleOpenGallery(event) {
        const { images, index } = event

        this.showImageIndex(images, index)
      },
      calculateHrnResult() {
        if (this.hrnSelected.po && this.hrnSelected.gpd && this.hrnSelected.fe && this.hrnSelected.np) {
          this.hrn_result = this.hrnSelected.po * this.hrnSelected.gpd * this.hrnSelected.fe * this.hrnSelected.np
        } else {
          this.hrn_result = 0
        }
      },
      formatHrnResult(hrn) {
        const hrnFormatted = parseFloat(hrn).toFixed(3)
        if (isNaN(hrnFormatted)) return ''
        return hrnFormatted
      },
    },
    mounted() {
      this.axios
        .get('/api/risk-analysis-metrics/all')
        .then((response) => {
          const { po, gpd, np, fe } = response.data.data

          this.poOptions = po
          this.gpdOptions = gpd
          this.npOptions = np
          this.feOptions = fe
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
</script>

<style lang="scss" scoped>
  .machine-apr-list {
    &__table {
      width: 100%;
    }

    &.print {
      font-size: 0.7rem;
    }
  }

  table {
    font-size: 0.8rem;

    table.inner-table {
      width: 100%;
      background-color: #fff;
      font-size: 0.7rem;

      tr,
      td {
        background-color: #fff;
      }

      tr.table-title td {
        background-color: #ccc;
        text-align: center;
        font-weight: bold;
        font-size: 0.7rem;
      }
    }
  }

  .table-image {
    max-width: 80px;
    max-height: 100px;
    object-fit: cover;
  }

  td:not(.no-padding) {
    padding: 5px;
  }

  .text-sm {
    font-size: 0.75rem;
  }

  .unacceptable {
    color: #fff;
  }

  .expandable-image {
    cursor: pointer;
  }

  textarea {
    height: 200px;
    width: 100%;
  }

  .close {
    margin-left: auto;
  }

  .analysis-images-gallery-grid {
      display: grid;
      grid-template-columns: 60px 60px;
      gap: 5px;

      .image-thumb-holder {
          width: 60px;
          height: 60px;
          display: inline-block;

          .image-thumb {
              width: 100%;
              height: 100%;
              object-fit: cover;
          }
      }
  }

  .radiobutton-wrapper {
    display: inline-flex;
    margin-right: 20px;
    margin-bottom: 10px;
    border-radius: 10px;
    padding: 5px 10px;

    .p-field-radiobutton {
      margin-bottom: 0;
    }

    label {
      margin-top: 10px;
    }
  }

  .hrn-result {
    padding: 5px 20px;
    width: 130px;
    text-align: center;
    border-radius: 4px;
  }

</style>
